import api from '../api';

const noteService = {
    // List notes (with optional params: team_id, tag, search)
    list: (params) => api.get('/notes', { params }),

    // Create a new note
    create: (payload) => api.post('/notes', payload),

    // Get note details
    show: (id) => api.get(`/notes/${id}`),

    // Update note
    update: (id, payload) => api.put(`/notes/${id}`, payload),

    // Delete note
    remove: (id) => api.delete(`/notes/${id}`),

    // === Sharing endpoints ===

    // Get sharing details for a note
    getShareDetails: (noteId) => api.get(`/notes/${noteId}/share`),

    // Share note with users
    share: (noteId, payload) => api.post(`/notes/${noteId}/share`, payload),

    // Update a user's permission on a shared note
    updateSharePermission: (noteId, userId, payload) =>
        api.put(`/notes/${noteId}/share/${userId}`, payload),

    // Remove a user's share access
    removeShare: (noteId, userId) =>
        api.delete(`/notes/${noteId}/share/${userId}`),

    // Get available users for sharing (exclude already shared)
    getAvailableUsersForSharing: (noteId) =>
        api.get(`/notes/${noteId}/share/available-users`),
};

export default noteService;
